import { differenceInMonths, isValid } from 'date-fns';
import React, { ReactNode } from 'react';

import { FormattedMessage } from '@skippay/core/i18n/intl';

const MINIMUM_MONTH_DURATION = 3;

export function selfEmployExistenceDurationValidator(value: string): ReactNode | null {
	const parsedDate = new Date(value);
	const now = new Date();

	if (!isValid(parsedDate)) {
		return null;
	}

	const unableToContinue = differenceInMonths(now, parsedDate) < MINIMUM_MONTH_DURATION;

	if (unableToContinue) {
		return (
			<FormattedMessage
				defaultMessage="Zadali jste datum správně? Je potřeba podnikat alespoň {duration} měsíce."
				id="validationError.selfEmployExistenceDurationCheck"
				values={{ duration: MINIMUM_MONTH_DURATION }}
			/>
		);
	}

	return null;
}
